import React, { useEffect, useState } from 'react'
import { CgSpinner } from 'react-icons/cg'
import useScrollBlock from '../../lib/useScrollBlock'
import { useAPI } from '../../contexts/api'

function LicenseAgreementGate() {
	const [blockScroll, allowScroll] = useScrollBlock()
	const [status, setStatus] = useState(null)
	const [approved, setApproved] = useState(false)
	const [submitting, setSubmitting] = useState(false)
	const [dismissed, setDismissed] = useState(false)
	const { getLicenseAgreementStatus, acceptLicenseAgreement } = useAPI()

	const showApprovalModal = status?.hasAcceptedCurrent === false && !dismissed

	useEffect(() => {
		loadStatus()
	}, [])

	useEffect(() => {
		if (!showApprovalModal) return
		blockScroll()
		return () => allowScroll()
	}, [showApprovalModal])

	async function loadStatus() {
		try {
			const status = await getLicenseAgreementStatus()			
			setStatus(status)
		} catch (err) {
			// Fail open: a failed check must never block the user
		}
	}

	function handleCheckboxChange({ target }) {
		setApproved(target.checked)
	}

	async function handleSubmit(ev) {
		ev.preventDefault()
		setSubmitting(true)

		try {
			const accepted = await acceptLicenseAgreement(status.currentVersion)
			setStatus(accepted)
		} catch (err) {
			// The user did approve - don't block them because we failed to record it.
			// Nothing was saved, so they will be asked again on their next visit.
			setDismissed(true)
		}

		setSubmitting(false)
	}

	if (!showApprovalModal) return null

	return (
		<>
			<div className='fixed inset-0 w-full h-full bg-black opacity-60' style={{ zIndex: 1000 }} />
			<div className='fixed inset-0 flex items-center justify-center p-4 overflow-y-auto' style={{ zIndex: 1001 }}>
				<div className='bg-white rounded-lg shadow-lg w-full max-w-md p-6 text-gray-800'>
					<h2 className='text-xl font-semibold mb-3'>תנאי השימוש עודכנו</h2>
					<p className='text-sm mb-4'>
						תנאי השימוש של המערכת עודכנו. כדי להמשיך להשתמש בזמן טוב יש לקרוא ולאשר את התנאים המעודכנים.
					</p>
					<a href={status.agreementUrl} target='_blank' rel='noopener noreferrer'
						className='text-green-600 font-medium text-sm underline block mb-5'>
						לקריאת תנאי השימוש
					</a>

					<form onSubmit={handleSubmit}>
						<label className='flex items-start mb-4 text-sm cursor-pointer'>
							<input type='checkbox' checked={approved} disabled={submitting} onChange={handleCheckboxChange}
								className='mt-0.5 ml-2 h-4 w-4' />
							<span>קראתי ואני מאשר/ת את תנאי השימוש</span>
						</label>

						<button type='submit' disabled={!approved || submitting}
							className='flex justify-center items-center disabled:opacity-50 text-center text-md w-full bg-green-500 h-12 rounded text-white py-3 font-medium outline-none focus:outline-none'>
							{submitting ? <CgSpinner className='mx-auto animate-spin' size={24} /> : <span>אני מאשר/ת</span>}
						</button>
					</form>

					<a href='/app/logout/' className='block text-center text-gray-400 text-xs mt-4'>יציאה מהחשבון</a>
				</div>
			</div>
		</>
	)
}

export default LicenseAgreementGate
